module.exports = __webpack_public_path__ + "img/3.4b8f2fa6.png";